var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2213 14.4477C24.9043 14.4477 28.7007 18.2767 28.7007 22.9999V34.4635C28.7007 36.0715 29.993 37.3749 31.5873 37.3749H38.0821C39.6763 37.3749 40.9687 36.0715 40.9687 34.4635C40.9687 32.8556 39.6763 31.5521 38.0821 31.5521H34.4739V22.9999C34.4739 15.0608 28.0928 8.62492 20.2213 8.62492C12.3498 8.62492 5.96871 15.0608 5.96871 22.9999C5.96871 30.939 12.3498 37.3749 20.2213 37.3749H20.5821C22.1763 37.3749 23.4687 36.0715 23.4687 34.4635V27.0941C23.4687 25.4862 22.1763 24.1827 20.5821 24.1827C18.9879 24.1827 17.6955 25.4862 17.6955 27.0941V31.1663C14.246 30.0822 11.7419 26.836 11.7419 22.9999C11.7419 18.2767 15.5383 14.4477 20.2213 14.4477Z",
    fill: "#FFA51D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logoIcon.0cf6017284d35fa858cb4c4a6d08ffce.svg";
export { ForwardRef as ReactComponent };